<div class="flex flex-col flex-nowrap justify-center items-center w-full gap-4">
  <div class="flex flex-row flex-nowrap justify-between items-center w-full">
    <p class="text-xl text-left">Zoho Books</p>
    <div class="flex flex-row flex-nowrap justify-start items-center gap-4">
      @if (!isExpanded()) {
        <button mat-raised-button (click)="isExpanded.set(true)">Expand All</button>
      } @else {
        <button mat-raised-button (click)="isExpanded.set(false)">Collapse All</button>
      }
    </div>
  </div>

  @if (_zohoBooksFeature.isCheckingAuth()) {
    <div class="w-full flex justify-center items-center pt-[20px]">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (!_zohoBooksFeature.isConnected()) {
    <div class="w-full flex flex-col justify-center items-center pt-[40px] gap-4">
      <p class="text-gray-600">Your Zoho Books account is not connected yet.</p>
      <button mat-raised-button color="primary" (click)="connectZoho()">Connect Zoho Account</button>
    </div>
  } @else if (_zohoBooksFeature.isLoadingTimeEntries()) {
    <div class="w-full flex justify-center items-center pt-[20px]">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    <app-zoho-books-filters class="w-full" (dateFilterChanged)="onDateFilterChanged()"></app-zoho-books-filters>

    <mat-accordion multi class="w-full">
      @if (_zohoBooksFeature.groupByDateTypes() === 'day') {

        @for (day of groupByDate(); track day.date) {
          <mat-expansion-panel [expanded]="isExpanded() || !!_zohoBooksFeature.searchText()">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ day.date | date:'dd/MM/yyyy' }}</mat-panel-title>
              <mat-panel-description>
                <p>Total hours: {{ day.totalHours | number: "1.0-2" }}</p>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <table class="w-full text-sm">
              <thead>
                <tr class="border-b border-black">
                  <th class="text-left font-bold pb-1 pr-4">Date</th>

                  <th class="text-left font-bold pb-1 pr-4">Project</th>
                  <th class="text-left font-bold pb-1 pr-4">Task</th>
                  <th class="text-left font-bold pb-1 pr-4">Notes</th>
                  <th class="text-right font-bold pb-1">Hours</th>
                </tr>
              </thead>
              <tbody>
                @for (entry of day.timeEntries; track entry.time_entry_id) {
                  <tr class="border-b border-gray-100 hover:bg-gray-50">
                    <td class="py-2 text-gray-500 whitespace-nowrap pr-4">{{ entry.log_date | date:'dd/MM/yyyy' }}</td>

                    <td class="py-2 text-gray-500 whitespace-nowrap pr-4" [innerHTML]="entry.project_name | highlight: _zohoBooksFeature.searchText()"></td>
                    <td class="py-2 whitespace-nowrap pr-4" [innerHTML]="entry.task_name | highlight: _zohoBooksFeature.searchText()"></td>
                    <td class="py-2 text-gray-600 w-full" [innerHTML]="entry.notes | highlight: _zohoBooksFeature.searchText()"></td>
                    <td class="py-2 text-right whitespace-nowrap">{{ toDecimalHours(entry.log_time) | number: "1.0-2" }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </mat-expansion-panel>
        } @empty {
          <div class="w-full flex justify-center items-center pt-[20px]">
            <p class="text-lg">No entries.</p>
          </div>
        }

      } @else if (_zohoBooksFeature.groupByDateTypes() === 'week') {

        @for (week of groupByWeek(); track week.startDateOfWeek) {
          <mat-expansion-panel [expanded]="isExpanded() || !!_zohoBooksFeature.searchText()">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ week.startDateOfWeek | date:'dd/MM/yyyy' }} to {{ week.endDateOfWeek | date:'dd/MM/yyyy' }}</mat-panel-title>
              <mat-panel-description>
                <p>Total hours: {{ week.totalHours | number: "1.0-2" }}</p>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <table class="w-full text-sm">
              <thead>
                <tr class="border-b border-black">
                  <th class="text-left font-bold pb-1 pr-4">Date</th>

                  <th class="text-left font-bold pb-1 pr-4">Project</th>
                  <th class="text-left font-bold pb-1 pr-4">Task</th>
                  <th class="text-left font-bold pb-1 pr-4">Notes</th>
                  <th class="text-right font-bold pb-1">Hours</th>
                </tr>
              </thead>
              <tbody>
                @for (day of week.timeEntriesByDay; track day.date) {
                  <tr class="bg-gray-50 border-t border-gray-200">
                    <td colspan="5" class="py-1 font-semibold text-gray-600">{{ day.date | date:'EEEE, dd/MM/yyyy' }}</td>
                    <td class="py-1 font-semibold text-gray-600 text-right whitespace-nowrap">Total: {{ day.totalHours | number: "1.0-2" }}</td>
                  </tr>
                  @for (entry of day.timeEntries; track entry.time_entry_id) {
                    <tr class="border-b border-gray-100 hover:bg-gray-50">
                      <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4">{{ entry.log_date | date:'dd/MM/yyyy' }}</td>

                      <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4" [innerHTML]="entry.project_name | highlight: _zohoBooksFeature.searchText()"></td>
                      <td class="py-2 px-2 whitespace-nowrap pr-4" [innerHTML]="entry.task_name | highlight: _zohoBooksFeature.searchText()"></td>
                      <td class="py-2 px-2 text-gray-600 w-full" [innerHTML]="entry.notes | highlight: _zohoBooksFeature.searchText()"></td>
                      <td class="py-2 px-2 text-right whitespace-nowrap">{{ toDecimalHours(entry.log_time) | number: "1.0-2" }}</td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </mat-expansion-panel>
        } @empty {
          <div class="w-full flex justify-center items-center pt-[20px]">
            <p class="text-lg">No entries for this week.</p>
          </div>
        }

      } @else {

        @for (month of groupByMonth(); track month.month) {
          <mat-expansion-panel [expanded]="isExpanded() || !!_zohoBooksFeature.searchText()">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ month.month }} ({{ month.year }})</mat-panel-title>
              <mat-panel-description>
                <p>Total hours: {{ month.totalHours | number: "1.0-2" }}</p>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <table class="w-full text-sm">
              <thead>
                <tr class="border-b border-black">
                  <th class="text-left font-bold pb-1 pr-4">Date</th>

                  <th class="text-left font-bold pb-1 pr-4">Project</th>
                  <th class="text-left font-bold pb-1 pr-4">Task</th>
                  <th class="text-left font-bold pb-1 pr-4">Notes</th>
                  <th class="text-right font-bold pb-1">Hours</th>
                </tr>
              </thead>
              <tbody>
                @for (day of month.timeEntriesByDay; track day.date) {
                  <tr class="bg-gray-50 border-t border-gray-200">
                    <td colspan="5" class="py-1 font-semibold text-gray-600">{{ day.date | date:'EEEE, dd/MM/yyyy' }}</td>
                    <td class="py-1 font-semibold text-gray-600 text-right whitespace-nowrap">Total: {{ day.totalHours | number: "1.0-2" }}</td>
                  </tr>
                  @for (entry of day.timeEntries; track entry.time_entry_id) {
                    <tr class="border-b border-gray-100 hover:bg-gray-50">
                      <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4">{{ entry.log_date | date:'dd/MM/yyyy' }}</td>

                      <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4" [innerHTML]="entry.project_name | highlight: _zohoBooksFeature.searchText()"></td>
                      <td class="py-2 px-2 whitespace-nowrap pr-4" [innerHTML]="entry.task_name | highlight: _zohoBooksFeature.searchText()"></td>
                      <td class="py-2 px-2 text-gray-600 w-full" [innerHTML]="entry.notes | highlight: _zohoBooksFeature.searchText()"></td>
                      <td class="py-2 px-2 text-right whitespace-nowrap">{{ toDecimalHours(entry.log_time) | number: "1.0-2" }}</td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </mat-expansion-panel>
        } @empty {
          <div class="w-full flex justify-center items-center pt-[20px]">
            <p class="text-lg">No entries for this month.</p>
          </div>
        }

      }
    </mat-accordion>
  }
</div>
